export class Interval {
    interval: any = new Object(); //undefined causes exceptions to clearInterval
    duration: number = 0;
}
